// services/hubApi.ts - Chamadas da Dinâmica à API do hub (entrega 1.6).
//
// Com o token do mesmo login (o do login único): quantas dinâmicas restam no dia (D109), os eventos de
// métrica (ADR-002) e a sugestão depois da dinâmica (D104). O hub aceita a origem da Dinâmica (D132, D159).

import { auth, tokenAppCheck } from './firebase';
import { hubUrl } from '../config/hub';

async function hubFetch(caminho: string, init: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser;
  if (!user) throw new Error('not_authenticated');
  const token = await user.getIdToken();
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const appCheck = await tokenAppCheck();
  if (appCheck) headers.set('X-Firebase-AppCheck', appCheck);
  return fetch(hubUrl(caminho), { ...init, headers });
}

export interface UsoDoDia {
  limite: number;
  usadas: number;
  restantes: number;
}

/** Uso de hoje na Dinâmica, pela licença do professor (ADR-001 §2.3). `null` se não souber. */
export async function usoDoDia(): Promise<UsoDoDia | null> {
  try {
    const r = await hubFetch('/api/account/licenca');
    if (!r.ok) return null;
    const j = (await r.json()) as { dinamica?: { limit: number; used: number; remaining: number } | null };
    if (!j.dinamica) return null;
    return { limite: j.dinamica.limit, usadas: j.dinamica.used, restantes: j.dinamica.remaining };
  } catch {
    return null;
  }
}

export type EventoDaDinamica =
  | { event: 'dinamica_pdf'; props: { atividade_id: string } }
  | { event: 'dinamica_whatsapp'; props: { atividade_id: string } }
  | { event: 'dinamica_feedback'; props: { atividade_id: string; ajudou: boolean } }
  | { event: 'limite_atingido'; props: { motivo: 'cota' | 'protecao' | 'global' } };

/** Evento de métrica: nunca segura a tela (ADR-002). */
export function registrarEvento(evento: EventoDaDinamica): void {
  void hubFetch('/api/events', { method: 'POST', keepalive: true, body: JSON.stringify(evento) }).catch(() => undefined);
}

/** O "Quer contar mais?" do feedback vai para as sugestões, com a dinâmica de origem (D104). */
export async function enviarComentario(texto: string, atividadeId: string | undefined): Promise<boolean> {
  try {
    const r = await hubFetch('/api/account/sugestao', {
      method: 'POST',
      body: JSON.stringify({ texto, origem: 'dinamica', ...(atividadeId ? { atividade_id: atividadeId } : {}) }),
    });
    return r.ok;
  } catch {
    return false;
  }
}
